import { createContext, type ReactNode } from 'react'
import type { AutocompletePanelProps } from './AutocompletePanel'

export type SearchbarPanelContextValue = Omit<AutocompletePanelProps, 'isOpen'>

export const SearchbarPanelContext =
  createContext<SearchbarPanelContextValue | null>(null)

export const SearchbarPanelProvider = ({
  value,
  children,
}: {
  value: SearchbarPanelContextValue
  children: ReactNode
}) => (
  <SearchbarPanelContext.Provider value={value}>
    {children}
  </SearchbarPanelContext.Provider>
)
